import { render, staticRenderFns } from "./ossForm.vue?vue&type=template&id=cb6ea996&scoped=true"
import script from "./ossForm.vue?vue&type=script&lang=js"
export * from "./ossForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6ea996",
  null
  
)

export default component.exports